import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=6ba2dc38&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba2dc38')) {
      api.createRecord('6ba2dc38', component.options)
    } else {
      api.reload('6ba2dc38', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=6ba2dc38&", function () {
      api.rerender('6ba2dc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/paye/upload.vue"
export default component.exports